export function isUnmappedTaskGroupLine(line: Record<string, unknown>): boolean {
  return line.is_task_group_unmapped === true;
}

export function countUnmappedTaskGroupLines(lines: Record<string, unknown>[]): number {
  return lines.filter(isUnmappedTaskGroupLine).length;
}

export function isMtoLineHighlighted(line: Record<string, unknown>): boolean {
  return isUnmappedTaskGroupLine(line) || line.is_matched === false;
}
